import * as React from 'react'
import {connect} from "react-redux"
import {ApplicationState} from "../../store"
import {Button, Paper} from "@material-ui/core"
import SaveIcon from "@material-ui/icons/Save"
import BaseTab, {BaseTabProps, BaseTabState} from "../BaseTab"
import FileUploader from "../../core/components/FileUploader"
import {Utility} from "../../core/Utility"
import {Tab} from "../Tab";
import {Validator} from "../../core/Validator"
import {PopupDialog} from "../../core/components/PopupDialog"
import {t} from "../../core/localization"
import {actionTenantFetchRequest, actionTenantSaveRequest} from "../../store/tenant"
import {Tenant, TenantDescriptor} from "../../models/Tenant"
import {Upload} from "../../models/Upload"
import {EntityFieldsDescriptor} from "../../core/genericdocuments/EntityFieldsDescriptor"
import {EntityField} from "../../core/genericdocuments/EntityField"
import {LookupDataRow} from "../../services/LookupDataRow"
import {LookupEntities} from "../../core/genericdocuments/ReferenceDetails"
import {FieldView} from "../components/FieldView"
import {tenantFieldsDescriptor} from "./TenantFields"

export interface TenantTabProps extends BaseTabProps{
	tab: Tab
	tenant: Tenant
}

export interface TenantTabState extends BaseTabState {
	isDeleteConfirmationDialogOpen: boolean;
	isDialogOpen: boolean,
	dialogTitle: string,
	dialogText: string,
	validation: any
}

function mapStateToProps(state: ApplicationState) {
	return {
		state: state.tabs.active.state,
		item: state.tabs.active.item,
		tab: state.tabs.active,
		tenant: state.tenant.tenant
	}
}

class TenantTab extends BaseTab<TenantTabProps, TenantTabState> {

	constructor(props: TenantTabProps) {
		super(props)
		this.state = {isDeleteConfirmationDialogOpen: false, isDialogOpen: false, dialogText: '', dialogTitle: '', validation: { valid: true, fields: [] }}
	}

	componentWillMount() {
	}

	componentWillReceiveProps(nextProps: TenantTabProps) {
	}

	componentDidMount() {
		actionTenantFetchRequest(this.props.tab.id)
	}

	render(): React.ReactNode {

		if (!this.props.item) return <div>Item no set</div>

		return (
			<div style={{padding: '10px'}}>
				{this.renderTabControls()}
				<div style={{display:'flex', flexDirection:'row', flex:'2', marginTop: '10px' }}>
					<div style={{flex:'1', marginRight: '20px'}}>
						<Paper style={{padding:'10px'}}>
							{this.renderForm()}
							{this.renderFormControls()}
						</Paper>
					</div>
					<div style={{flex:'1'}}>
						<Paper style={{padding:'10px'}}>
							{this.props.item.id && <FileUploader
								itemId={this.props.item.id}
								itemType={'Tenant'}
								uploads={this.props.item.uploads}
								onUpload={this.onUpload.bind(this)}
								onDelete={this.onFileDelete.bind(this)}/>}
							{!this.props.item.id && <p style={{textAlign: 'center'}}>{t.SaveItem}</p>}
						</Paper>
					</div>
				</div>
				{this.renderPopupDialog()}
			</div>
		)
	}

	renderForm(): React.ReactNode {

		let descriptor: EntityFieldsDescriptor<any> = tenantFieldsDescriptor

		return (<div className="create-form">
		{
			descriptor && descriptor.createFormFields.map(
				(entityField: EntityField<any>, index: number) => {
					const fieldName = entityField.name.toString()
					let value = Utility.formatString(this.getItemFromTabState(fieldName))
					return (
						<div style={{ marginBottom: "0px", padding: "0px" }}>
							{<FieldView value={value}
									autoFocus={index === 0} field={entityField} formState={null}
									setFormState={null}
									handleInputChange={(fieldName, value) => this.handleItemGenericInputChange(fieldName, value)}
									validationState={this.state.validation}
									lookupData={this.getLookupData.bind(this)}
								/>}
							</div>
						)
					}
				)
			}
		</div>
		)
	}

	getLookupData(lookupEntity: LookupEntities): LookupDataRow[] {
		switch (lookupEntity) {
			case LookupEntities.Tenants: {
				return this.props.tenant.uploads.map((tenant: Upload) => {return {label: `${tenant.name}`, value: tenant.id, data: tenant}})
			}
		}
	}

	renderFormControls(): React.ReactNode {
		return <div style={{display: 'flex', flexDirection:'row-reverse', marginTop: '10px'}}>
				<Button onClick={this.onSaveClick.bind(this)} variant="contained" color="primary" style={{}}><SaveIcon />{t.Save}</Button>
			</div>
	}

	renderTabControls(): React.ReactNode {
		return <div style={{display: 'flex', flexDirection:'row-reverse'}}>
			{/*<IconButton*/}
			{/*	aria-label="more"*/}
			{/*	aria-controls="long-menu"*/}
			{/*	aria-haspopup="true"*/}
			{/*	onClick={this.openDeleteConfirmationModal.bind(this)}>*/}
			{/*	<DeleteIcon />*/}
			{/*</IconButton>*/}
		</div>
	}

	// renderDeleteConfirmationDialog(): React.ReactNode {
	// 	return <DeleteConfirmation
	// 		isOpen={this.state.isDeleteConfirmationDialogOpen}
	// 		onDeleteConfirm={() => this.onDeleteConfirmClick()}
	// 		onToggleModal={() => this.onToggleDeleteConfirmationModal()}
	// 	/>
	// }

	renderPopupDialog(): React.ReactNode {
		return <PopupDialog
			isOpen={this.state.isDialogOpen}
			title={this.state.dialogTitle}
			text={this.state.dialogText}
			onClose={this.onDialogClose.bind(this)}
		/>
	}

	onSaveClick () {
		let itemToSave = this.getItemFromTabState()
		if (Validator.validateItem(itemToSave, TenantDescriptor)) {
			actionTenantSaveRequest(itemToSave)
			// actionActiveTabTitle(t.Contract + ': ' + this.getItemFromTabState('title'))
		} else {
			this.setState({ ...this.state, isDialogOpen: true, dialogTitle: t.Warning, dialogText: 'Neispravni podaci'});
		}
	}

	onUpload () {
		actionTenantFetchRequest(this.props.tab.id)
	}

	onFileDelete () {
		actionTenantFetchRequest(this.props.tab.id)
	}

	openDeleteConfirmationModal() {
		this.setState({ ...this.state, isDeleteConfirmationDialogOpen: true});
	}

	onToggleDeleteConfirmationModal(){
		this.setState({ ...this.state, isDeleteConfirmationDialogOpen: !this.state.isDeleteConfirmationDialogOpen});
	}

	// onDeleteConfirmClick(){
	// 	actionContractDelete(this.props.item)
	// 	actionDeleteTab(this.props.tab)
	// }

	onDialogClose () {
		this.setState({ ...this.state, isDialogOpen: false})
	}
}

export default connect(mapStateToProps)(TenantTab)